import { getCache, setCache } from '@/utils/session';
// import {translateResource} from '@/api/userManage';
import axios from 'axios';
// import langJson from '/public/lang.json';
const state = {
  open: true,
  fixHeader: getCache('FIX_HEARDER') == null ? true : getCache('FIX_HEARDER'),
  tagShow: getCache('TAG_SHOW') == null ? true : getCache('TAG_SHOW'),
  settingVisible: false,
  layout: getCache('LAYOUT') || 'inline',
  theme: getCache('THEME') || 'blue',
  locale: 'zh_CN',
  localeResource: {},
  chooseInvoice: sessionStorage.getItem('chooseInvoice') || ''
};
const mutations = {
  TOGGLE_OPEN(state) {
    state.open = !state.open;
  },
  CHANGE_SETTING(state, {
    key,
    value,
    cache
  }) {
    // eslint-disable-next-line
    if (state.hasOwnProperty(key)) {
      state[key] = value;
      setCache(cache, value);
    }
  },
  CHANGE_VISIBLE(state, bool) {
    state.settingVisible = bool;
  },
  CHANGE_LOCALE(state, key) {
    state.locale = key;
  },
  LOCALE_RESOURCE(state, obj) {
    state.localeResource = obj;
  },
  SET_CHOOSEINVOICE(state, obj) {
    // 存储到本地并且存储到vuex
    sessionStorage.setItem('chooseInvoice', JSON.stringify(obj));
    state.chooseInvoice = JSON.stringify(obj);
  }
};
const actions = {
  changeSetting({
    commit
  }, setting) {
    commit('CHANGE_SETTING', setting);
  },
  changeVisible({
    commit
  }, bool) {
    commit('CHANGE_VISIBLE', bool);
  },
  getLocaleResource({
    commit
  }) {
    // console.log(process.env);
    return new Promise((resolve, reject) => {
      // sessionStorage.setItem('localeResource', JSON.stringify(langJson));
      // resolve(langJson);
      // translateResource({})
      let url = process.env.VUE_APP_File + '/insurforce/translation.json' + '?' + new Date().getTime();
      axios.get(url).then(res => {
        commit('LOCALE_RESOURCE', res.data);
        sessionStorage.setItem('localeResource', JSON.stringify(res.data));
        resolve(res.data);
      }).catch(err => {
        sessionStorage.setItem('localeResource', JSON.stringify({
          zh_CN: {},
          zh_TW: {},
          en_US: {},
          fr_FR: {},
          ru_RU: {},
          es_ES: {}
        }));
        reject(err);
      });
    });
  },
  setChooseInvoice({
    commit
  }, obj) {
    commit('SET_CHOOSEINVOICE', obj);
  }
};
export default {
  namespaced: true,
  state,
  mutations,
  actions
};